import { useState } from "react";
import { Field } from "redux-form";

import { mapEmailErrorCode } from "@js/apps/auth/utils";
import type { TextFieldProps } from "@js/forms/fields/text";
import { TextField } from "@js/forms/fields/text";

type SignUpEmailFieldProps = {
  variant?: "talent" | "business";
  required?: boolean;
  disableWhenPrefilled?: boolean;
};
export const SignUpEmailField = ({
  disableWhenPrefilled,
  variant = "talent",
  required = true,
}: SignUpEmailFieldProps) => {
  const placeholderEnd =
    variant === "business" ? "business email" : "email address";

  const label =
    variant === "business"
      ? `Business email${required ? "*" : ""}`
      : `Email${required ? "*" : ""}`;

  return (
    <Field
      variant="outlined"
      color="secondary"
      name="email"
      id="email"
      component={SignupEmailTextField}
      placeholder={`Enter your ${placeholderEnd}`}
      mapErrorCode={(email: string) => mapEmailErrorCode(email, true)}
      label={label}
      disableWhenPrefilled={disableWhenPrefilled}
    />
  );
};

type SignupEmailTextFieldProps = TextFieldProps & {
  disableWhenPrefilled?: boolean;
};
const SignupEmailTextField = ({
  disableWhenPrefilled,
  ...props
}: SignupEmailTextFieldProps) => {
  const [isPrefilled] = useState(!!props.input.value);
  const disabled = !!disableWhenPrefilled && isPrefilled;

  return <TextField {...props} disabled={disabled} />;
};
